import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GuideKpiCard } from '../../../theme/components/GuideKpiCard';
import { formatCurrencyAmount } from '../../../commons/currency/Currency.Functions';
import { useSettlements } from '../Dashboard.Hooks';
import { WidgetProps } from '../Dashboard.Types';
import { WidgetData } from './WidgetData';
import { SettlementGroupSummary, settlementGroupTone, summarizeSettlements } from './Widgets.Functions';

const amountText = (summary: SettlementGroupSummary): string =>
  summary.amounts.length === 0 ? '—' : summary.amounts.map((item) => formatCurrencyAmount(item.amount, item.currencyCode)).join(' · ');

/** KPIs de liquidaciones por estado: en cálculo, pendientes de aprobación, a cobrar, pagadas y fallidas. */
export const SettlementsSummaryWidget = (_props: WidgetProps) => {
  const { t } = useTranslation();
  const settlements = useSettlements();
  const summary = React.useMemo(() => summarizeSettlements(settlements.list), [settlements.list]);

  return (
    <WidgetData loading={settlements.loading} failed={settlements.failed} error={settlements.error} onRetry={settlements.reload} rows={2}>
      <div className="dbw-kpis" data-testid="settlements-summary">
        {summary.map((item) => (
          <Link key={item.group} to="/settlements/" className="dbw-kpis__link" data-testid={`settlements-summary-${item.group}`}>
            <GuideKpiCard
              className="dbw-kpis__card"
              label={t(`dashboard.widgets.settlementsSummary.groups.${item.group}`)}
              value={item.count}
              tone={item.count > 0 ? settlementGroupTone[item.group] : 'neutral'}
              detail={amountText(item)}
              valueTestId={`settlements-summary-${item.group}-count`}
            />
          </Link>
        ))}
      </div>
    </WidgetData>
  );
};

export default SettlementsSummaryWidget;
